export { colors, Colors } from './colors';
